import { useEffect, useState } from 'react'
import { PreparePurchaseLessonPack, SetMarketingOptIn } from './query'
import { useMutation } from '@apollo/client'

export const useGetClientSecret = lessonPackId => {
  const [clientSecret, setClientSecret] = useState(null)
  const [preparePurchaseLessonPack, { data, loading, error }] = useMutation(
    PreparePurchaseLessonPack,
  )

  useEffect(() => {
    // Reset clientSecret when lesson pack changes to ensure clean state
    setClientSecret(null)
    if (lessonPackId) {
      preparePurchaseLessonPack({
        variables: {
          lessonPackId,
        },
      })
    }
  }, [lessonPackId, preparePurchaseLessonPack])

  useEffect(() => {
    if (data?.preparePurchaseLessonPack?.success) {
      setClientSecret(
        data?.preparePurchaseLessonPack?.paymentIntent?.clientSecret,
      )
    }
  }, [data])

  return { clientSecret, loading, error }
}

export const useSetMarketingOptIn = () => {
  const [setMarketingOptInMutation, { data, loading, error }] = useMutation(
    SetMarketingOptIn,
  )

  const setMarketingOptIn = marketingOptInChecked => {
    const marketingOptInAt = marketingOptInChecked
      ? (() => {
        const date = new Date()
        date.setSeconds(0, 0)
        return date.toISOString()
      })()
      : null

    setMarketingOptInMutation({
      variables: { marketingOptInAt },
    })
  }

  return { setMarketingOptIn, data, loading, error }
}
